import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { DenialReason } from 'src/app/global/services/config-all/config-all.model';

export interface UserRequestDenyData {
    title: string;
    body: {
        label: string;
        placeholder: string;
        error: string;
        button: string;
        presetTab?: string;
        customTab?: string;
    };
    denialReasons?: DenialReason[];
}

@Component({
    selector: 'app-user-request-deny-dialog',
    templateUrl: './user-request-deny-dialog.component.html',
    styleUrls: ['./user-request-deny-dialog.component.scss'],
})
export class UserRequestDenyDialogComponent implements OnInit, OnDestroy {
    public destroy$ = new Subject();

    requestDenyForm = this.formBuilder.group({
        reason: new FormControl('', [Validators.required]),
    });

    mode: 'preset' | 'custom' = 'custom';
    selectedReasonIds: Set<string> = new Set();

    @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<UserRequestDenyDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UserRequestDenyData,
    ) {}

    get reason(): AbstractControl {
        return this.requestDenyForm.get('reason');
    }

    get hasPresetReasons(): boolean {
        return this.data.denialReasons?.length > 0;
    }

    get canSubmit(): boolean {
        if (this.mode === 'preset') {
            return this.selectedReasonIds.size > 0;
        }
        return this.requestDenyForm.get('reason').value?.trim().length > 0;
    }

    ngOnInit(): void {
        console.log(this.data.denialReasons);
        this.mode = this.hasPresetReasons ? 'preset' : 'custom';
    }

    toggleReason(reasonId: string): void {
        if (this.selectedReasonIds.has(reasonId)) {
            this.selectedReasonIds.delete(reasonId);
        } else {
            this.selectedReasonIds.add(reasonId);
        }
    }

    isSelected(reasonId: string): boolean {
        return this.selectedReasonIds.has(reasonId);
    }

    setMode(mode: 'preset' | 'custom'): void {
        this.mode = mode;
    }

    submit(): void {
        if (this.mode === 'preset') {
            const selectedReasons = this.data.denialReasons.filter((r) => this.selectedReasonIds.has(r.id)).map((r) => r.citizenReason);
            if (selectedReasons.length === 1) {
                this.onSubmit.emit(selectedReasons[0]);
            } else if (selectedReasons.length > 1) {
                const formatted = `<br>${selectedReasons.map((r, i) => `${i + 1}. ${r}`).join('<br>')}`;
                this.onSubmit.emit(formatted);
            }
        } else {
            this.requestDenyForm.markAllAsTouched();
            if (this.requestDenyForm.valid) {
                this.onSubmit.emit(this.requestDenyForm.get('reason').value);
            }
        }
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
